import React from 'react';
import { Box, TextField, Typography, Button, IconButton } from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import HomeIcon from '@material-ui/icons/Home';
import EmailIcon from '@material-ui/icons/Email';
import SmartphoneIcon from '@material-ui/icons/Smartphone';
import { makeStyles, withStyles } from '@material-ui/core/styles';
//Css Style
const useStyles = makeStyles((theme) => ({
    mainContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'start',
        paddingTop: '10%'
    },
    [theme.breakpoints.down(768)]: {
        "mainContainer": {
            flexDirection: 'column',
            padding: '1rem',
        },
        "makeStyles-rightSide-13": {
            borderLeft: 'none',
        },
    },
    button: {
        color: 'tomato',
        marginTop: '1rem',
        borderColor: 'tomato'
    },
    heading: {
        color: 'tan'
    },
    leftSide: {
        minWidth: '45%',
        padding: '1.5rem'

    },
    rightSide: {
        borderLeft: '2px solid tan',
        minWidth: '45%',
        padding: '1.5rem'
    },
    iconColor: {
        color: 'tomato'
    },
    title: {
        color: 'tan'
    }


}));
//Css Style
const InputField = withStyles({
    root: {
        "& label.Mui-focused": {
            color: 'tomato'
        },
        "& label": {
            color: 'tan'
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: 'tan'
            },
            "&:hover fieldset": {
                borderColor: 'tan'
            },
            "&.Mui-focused fieldset": {
                borderColor: 'tan'
            }
        }
    },


})(TextField);


const Contact = () => {
    const classes = useStyles();


    const onSubmit = e => {

    }

    return (
        <Box component={"div"} className={classes.mainContainer}>
            <Box component={"div"} className={classes.leftSide}>
                <Typography variant="h5" color="secondary">Discuss Now</Typography>
                <Typography variant="h6" className={classes.title}>
                    <IconButton edge="start" aria-label="menu">
                        <HomeIcon className={classes.iconColor} />
                    </IconButton>
                        House No#6/A,Post Office Road,East Rampura,Rampura, Dhaka-1219
                </Typography>

                <Typography variant="h6" className={classes.title}>
                    <IconButton edge="start" aria-label="menu">
                        <EmailIcon className={classes.iconColor} />
                    </IconButton>
                        asikur.cse@gmail.com
                     </Typography>

                <Typography variant="h6" className={classes.title}>
                    <IconButton edge="start" aria-label="menu">
                        <SmartphoneIcon className={classes.iconColor} />
                    </IconButton>
                        +8801823980517
                </Typography>


            </Box>

            <Box className={classes.rightSide} >
                
                    <Typography className={classes.heading} variant="h5">Contact with me...</Typography>
                <form onSubmit={onSubmit}>
                    <InputField fullWidth={true} inputProps={{ style: { color: '#fff' } }} margin="dense" size="medium" label="Name" variant="outlined" required/>
                    <InputField fullWidth={true} inputProps={{ style: { color: '#fff' } }} margin="dense" size="medium" label="Email" variant="outlined" />
                    <InputField fullWidth={true} inputProps={{ style: { color: '#fff', height: '5rem' } }} margin="dense" size="medium" label="Message" variant="outlined" />
                    <Button variant="outlined" className={classes.button} fullWidth={true} endIcon={<SendIcon />} >Leave a Message</Button>
                </form>
               
            </Box>

        </Box>
    );
};

export default Contact;